import React, { useState } from 'react';
import Nav from '../Components/Nav';
import Footer from '../Components/Footer';
import Card from '../Components/Card';
import Glitch from '../Assets/nftgifs/Glitch_Module.gif';
import Bad from '../Assets/nftgifs/Bad_USB.gif';
import Tri from '../Assets/nftgifs/Tri_Fi.gif';
// import { pairHashPack, purchaseWithHbar } from '../Utils/hashconnect';
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBTooltip } from 'mdb-react-ui-kit';


    export default function Mint() {    
        
        const [metadata, setMetadata] = useState(null);

        const pairingCallback = (metadata) => {
          setMetadata(metadata);
        };

        // useEffect(() => { 
        //     if (metadata === null) { pairHashPack({ pairingCallback }) }
        // },[metadata]);

        // Copy Token Id Handlers
        const copyGlitch = () => {
            navigator.clipboard.writeText('0.0.930744');
            alert('Glitch_Module Token Id has been Copied.');
        }
        const copyBad = () => {
            navigator.clipboard.writeText('0.0.930746');
            alert('Bad_USB Token Id has been Copied.');
        }
        const copyTri = () => {
            navigator.clipboard.writeText('0.0.930758');
            alert('Tri_Fi Token Id has been Copied.');
        }

        // const handleTransaction = async ({amount}) => {
        //     const transaction = await purchaseWithHbar({ amount })
        //     .then(result => result)
        //     .catch(error => error)
          
        //     if (transaction.error) {
        //         // Someting went wrong with the transaction
        //     } else {
        //         // Transaction completed successfully
        //     }
        // }
    
    return (

        <MDBContainer fluid className='pt-5 px-5 text-center'>
            <Nav />
{/* Cards ---------------------------------------------------------------------------------------------------------*/}
            <MDBRow className='pt-5'>
                <h1 className='text-black'>Gadget Series NFTs</h1>
                <MDBCol className='py-4'>
                    <Card
                        style={{maxWidth: '70vw', backgroundColor: 'rgba(120, 120, 120, .5)', border: '1px solid rgba(168, 168, 168, .5)', borderRadius: '10px'}}
                        className='mx-auto'
                        name='Glitch_Module'
                        img={Glitch}
                        about={<li>Rarity: Common</li>}
                        tokenId={
                            <li>Token ID: 0.0.930744
                                <MDBBtn outline color="dark" className="bgOverlay mx-3" floating size='sm' role='button' onClick={copyGlitch}>
                                    <MDBIcon far icon="copy" className='text-white' />
                                </MDBBtn>
                            </li>}
                        hbarPrice={<li>HBAR Price: Coming Soon..</li>}
                        usdcPrice={<li>USDC Price: $100</li>}
                        quantity={<li>Quantity: 3000</li>}
                        button0={
                            <MDBTooltip placement='top' title="Before continuing, please note: You must associate the NFT Token ID to receive it. When asked for your address in Coinbase, please input your Hedera Account ID.">
                                <a className='text-white' href="https://commerce.coinbase.com/checkout/9032bba1-75c0-43c9-abda-6cb4757a99a5">Purchase with Coinbase</a>
                            </MDBTooltip>}
                        button1={<MDBBtn disabled >Purchase with Hbar</MDBBtn>}
                            // onClick={ () => handleTransaction({amount: 5})}
                        />  
                </MDBCol>

                <MDBCol className='py-4'>
                    <Card 
                        style={{maxWidth: '70vw', backgroundColor: 'rgba(120, 120, 120, .5)', border: '1px solid rgba(168, 168, 168, .5)', borderRadius: '10px'}}
                        className='mx-auto'
                        name='Bad_USB' 
                        img={Bad}
                        about={<li>Rarity: Uncommon</li>}
                        tokenId={
                            <li>Token ID: 0.0.930746  
                                <MDBBtn outline color="dark" className="bgOverlay mx-3" floating size='sm' role='button' onClick={copyBad}>
                                    <MDBIcon far icon="copy" className='text-white' />
                                </MDBBtn>
                            </li>}
                        hbarPrice={<li>HBAR Price: Coming Soon..</li>}
                        usdcPrice={<li>USDC Price: $200</li>}
                        quantity={<li>Quantity: 1500</li>}
                        button0={
                            <MDBTooltip placement='top' title="Before continuing, please note: You must associate the NFT Token ID to receive it. When asked for your address in Coinbase, please input your Hedera Account ID.">
                                <a className='text-white' href="https://commerce.coinbase.com/checkout/6b53af3f-df34-4394-b8c3-3f6c4f86ded8">Purchase with Coinbase</a>
                            </MDBTooltip>}
                        button1={<MDBBtn disabled >Purchase with Hbar</MDBBtn>} 
                        />    
                </MDBCol>

                <MDBCol className='py-4'>
                    <Card
                        style={{maxWidth: '70vw', backgroundColor: 'rgba(120, 120, 120, .5)', border: '1px solid rgba(168, 168, 168, .5)', borderRadius: '10px'}} 
                        className='mx-auto'
                        name='Tri_Fi' 
                        img={Tri}
                        about={<li>Rarity: Rare</li>}
                        tokenId={
                            <li>Token ID: 0.0.930758  
                                <MDBBtn outline color="dark" className="bgOverlay mx-3" floating size='sm' role='button' onClick={copyTri}>
                                    <MDBIcon far icon="copy" className='text-white'/>
                                </MDBBtn>
                            </li>}
                        hbarPrice={<li>HBAR Price: Coming Soon..</li>}
                        usdcPrice={<li>USDC Price: $350</li>}
                        quantity={<li>Quantity: 500</li>}
                        button0={
                            <MDBTooltip placement='top' title="Before continuing, please note: You must associate the NFT Token ID to receive it. When asked for address in Coinbase, Please input your Hedera Account ID.">
                                <a className='text-white' href="https://commerce.coinbase.com/checkout/6518224c-a11d-49da-95bc-76b523642eb0">Purchase with Coinbase</a>
                            </MDBTooltip>}
                        button1={<MDBBtn disabled >Purchase with Hbar</MDBBtn>}
                        />  
                </MDBCol>                
            </MDBRow> 
                   
            <Footer />
      </MDBContainer>
    );
  }